/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./layout_actions');

/*
 **  PAGES
 */
require('./pages/home/home');
require('./pages/catalog/filters');
require('./pages/car/car_detail');
require('./libs/lazysizes.min');

/*
 **  USER DASHBOARD
 */
require('./pages/user_dashboard_actions');
import VModal from 'vue-js-modal'
window.Vue = require('vue');
Vue.use(require('vue-cookies'));
Vue.use(VModal)

import { HasError } from "vform";
Vue.component(HasError.name, HasError);

import InfiniteLoading from 'vue-infinite-loading';

Vue.use(InfiniteLoading, {});


// Vue i18n
import i18n from './libs/i18n'

// import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
// Vue.component('font-awesome-icon', FontAwesomeIcon);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

/*
 ** LAYOUT **
 */
Vue.component('star-rate-component', require('./components/front/layout/StarRateComponent.vue').default);
Vue.component('thumbnail-car-component', require('./components/front/layout/ThumbnailCarComponent.vue').default);
Vue.component('compare-button-component', require('./components/front/layout/CompareButtonComponent.vue').default);
Vue.component('compare-tray-component', require('./components/front/layout/CompareTrayComponent.vue').default);
Vue.component('whatsapp-button-component', require('./components/front/layout/WhatsappButtonComponent.vue').default);
Vue.component('appointment-button-component', require('./components/front/layout/AppointmentButtonComponent.vue').default);
Vue.component('brand-new-appointment-button-component', require('./components/front/layout/BrandNewAppointmentButtonComponent.vue').default);
Vue.component('cookie-consent-banner', require('./components/front/layout/cookieConsentBanner.vue').default);
Vue.component('chat-float-component', require('./components/front/layout/ChatFloatComponent.vue').default);
Vue.component('simulator-button-component', require('./components/front/layout/SimulatorButtonComponent.vue').default);
Vue.component('cookie-selected-state', require('./components/front/layout/SelectedState.vue').default);
Vue.component('input-search', require('./components/front/layout/InputSearch.vue').default);
Vue.component('favoritos', require('./components/front/favoritos.vue').default);
Vue.component('unauth-options', require('./components/front/unauth-options.vue').default);
Vue.component('profile_favorite_cards', require('./components/front/profile_favorite_cards.vue').default);
Vue.component('profile_profile', require('./components/front/profile_profile.vue').default);
Vue.component('slider-brands-mobile', require('./components/front/layout/SliderBrandsMobile.vue').default);
Vue.component('slider-brands-gray-mobile', require('./components/front/layout/SliderBrandsGrayMobile.vue').default);
Vue.component('partners-component', require('./components/front/layout/PartnersComponent.vue').default);

/* TEMP */
Vue.component('send-user-data-component', require('./components/front/pages/SendUserDataComponent.vue').default);

/*
 ** PAGES **
 */
Vue.component('checkout-component', require('./components/front/pages/CheckoutComponent.vue').default);

Vue.component('upload-car-component', require('./components/front/pages/upload_car/UploadCarComponent.vue').default);
Vue.component('upload-gallery', require('./components/front/pages/upload_car/UploadGalleryComponent.vue').default);
Vue.component('upload-cover', require('./components/front/pages/upload_car/UploadCoverComponent.vue').default);

Vue.component('car-media-component', require('./components/front/pages/car_detail/CarMediaComponent.vue').default);
Vue.component('swiper-media-component', require('./components/front/pages/car_detail/SwiperMediaComponent.vue').default);
Vue.component('modal-gallery-component', require('./components/front/pages/car_detail/ModalGalleryComponent.vue').default);
Vue.component('date-sheet-component', require('./components/front/pages/car_detail/DataSheetComponent.vue').default);
Vue.component('maxi-form-component', require('./components/front/pages/car_detail/MaxiFormComponent.vue').default);
Vue.component('data-sheet-component', require('./components/front/pages/car_detail/DataSheetComponent.vue').default);
Vue.component('data-value-added-component', require('./components/front/pages/car_detail/DataValueAddedComponent.vue').default);
// Vue.component('date-form-component', require('./components/front/pages/car_detail/DateFormComponent').default);
Vue.component('car-data-component', require('./components/front/pages/car_detail/CarDataComponent.vue').default);
Vue.component('feature-mini-component', require('./components/front/pages/car_detail/FeatureMiniComponent.vue').default);
Vue.component('similar-car', require('./components/front/pages/car_detail/SimilarCarComponent.vue').default);


Vue.component('documents-verify', require('./components/front/user_dashboard/DocumentsVerify.vue').default);
Vue.component('compare-details-component', require('./components/front/pages/comparator_car/CompareDetailsComponent.vue').default);
Vue.component('social-share-compare-component', require('./components/front/pages/comparator_car/SocialShareCompareComponent.vue').default);

/*
 ** PAGES  - HOME **
 */
Vue.component('featured-cars-component', require('./components/front/pages/home/FeaturedCarsComponent.vue').default);
Vue.component('cars-slider-component', require('./components/front/pages/home/CarsSliderComponent.vue').default);
Vue.component('brands-component', require('./components/front/pages/home/BrandsComponent.vue').default);
Vue.component('car-types-component', require('./components/front/pages/home/CarTypesComponent.vue').default);
Vue.component('advertising-component', require('./components/front/pages/home/AdvertisingComponent.vue').default);
Vue.component('last-views-component', require('./components/front/pages/home/LastViewsComponent.vue').default);
Vue.component('packages-component', require('./components/front/pages/home/PackagesComponent.vue').default);

Vue.component('main-search-component', require('./components/front/pages/filters/SearchComponent.vue').default);

Vue.component('slider-home-component', require('./components/front/pages/home/SliderHomeComponent.vue').default);
Vue.component('stepper-buy-car', require('./components/front/pages/home/StepperBuyCar.vue').default);
Vue.component('slider-filters-component', require('./components/front/pages/filters/SliderFiltersComponent.vue').default);
Vue.component('expired-find-car-reactivation', require('./components/front/pages/filters/ExpiredFindCarReactivation.vue').default);
Vue.component('price-filter-input-component', require('./components/front/layout/PriceFilterInputComponent.vue').default);

/*
 ** PAGES  - CATALOG **
 */
Vue.component('catalog-component', require('./components/front/pages/catalog/CatalogComponent.vue').default);
Vue.component('body-shops-catalog-component', require('./components/front/pages/catalog/BodyShopsCatalogComponent.vue').default);
Vue.component('blog-posts-catalog-component', require('./components/front/pages/catalog/BlogPostsCatalogComponent.vue').default);
Vue.component('blog-post-detail-component', require('./components/front/pages/catalog/BlogPostDetailComponent.vue').default);
Vue.component('affiliates-catalog-component', require('./components/front/pages/catalog/AffiliatesCatalogComponent.vue').default);
Vue.component('car-service-affiliates-catalog-component', require('./components/front/pages/catalog/CarServiceAffiliatesCatalogComponent.vue').default);

/*
 ** PAGES  - ADVANCED_FILTERS**
 */
Vue.component('advanced-search', require('./components/front/pages/advanced_search/AdvancedSearch.vue').default);

/*
 ** PAGES  -   Agency **
 */
Vue.component('agency-catalog-component', require('./components/front/pages/agency/AgencyCatalogComponent.vue').default);

/*
 ** AUTH **
 */
Vue.component('auth-modal', require('./components/front/authModal.vue').default);
Vue.component('auth-user', require('./components/front/authUser.vue').default);
Vue.component('value-car-component', require('./components/front/pages/ValueCarComponent.vue').default);

/**
 * USER DASHBOARD
 * **/
// Vue.component('my-ads-component', require('./components/front/user_dashboard/MyAdsComponent.vue').default);
// Vue.component('user-data', require('./components/front/user_dashboard/UserData.vue').default);
// Vue.component('agency-request-component', require('./components/front/user_dashboard/AgencyRequestComponent.vue').default);

/**
 * User desired car
 */
Vue.component('user-find-car', require('./components/front/pages/user_find_car/UserFindCar.vue').default);

/**
 * Brand new vehicles section v2.0
 */
Vue.component('slider-new-vehicles-filters-component', require('./components/front/pages/filters/SliderNewVehicleFiltersComponent.vue').default);
Vue.component('search-new-vehicles-component', require('./components/front/pages/filters/SearchNewVehiclesComponent.vue').default);
Vue.component('catalog-new-vehicles-component', require('./components/front/pages/catalog_new_vehicle/CatalogComponent.vue').default);
Vue.component('whatsapp-new-vehicles-button-component', require('./components/front/layout/NewVehicles/WhatsappButtonComponent.vue').default);

// Facebook
Vue.component('facebook-login-button', require('./components/front/facebook/LoginButton.vue').default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import store from './store';

if (typeof (firebase) !== 'undefined') {
    const firebaseConfig = {
        apiKey: "AIzaSyCQRVB9UeLD1Yrt5-HFlqZGLupYfwz_AY0",
        authDomain: "turn-a97cc.firebaseapp.com",
        databaseURL: "https://turn-a97cc.firebaseio.com",
        projectId: "turn-a97cc",
        storageBucket: "turn-a97cc.appspot.com",
        messagingSenderId: "804971310753",
        appId: "1:804971310753:web:270ac05a25596d96730ae0"
    };
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
}

//Currency filter
import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter, {
    symbol: '$',
    thousandsSeparator: ',',
    fractionCount: 0,
    fractionSeparator: '',
    symbolPosition: 'front',
    symbolSpacing: true,
    avoidEmptyDecimals: 0,
});

import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        sm: 420,
        md: 1250,
        lg: Infinity,
    },
    defaultBreakpoint: 'sm' // customize this for SSR
})

export const bus = new Vue()

const app = new Vue({
    el: '#app',
    store,
    i18n,
    data: {
        loginModal: false,
        renderApp: false
    },
    created() {
        // this.$store.dispatch('getAuth');
        // this.$store.dispatch('comparative/getComparatives');
        if (!!!this.$cookies.get('lodaded')) {
            this.createCacheCookie();
        }
    },
    mounted() {
        let vm = this;
        setTimeout(function () {
            vm.renderApp = true;
        }, 1000);
    },
    methods: {
        createCacheCookie() {
            let nextDay = new Date();
            nextDay.setTime(nextDay.getTime() + 1 * 24 * 60 * 60 * 1000);
            this.$cookies.set("lodaded", 'true', nextDay.toUTCString());
            localStorage.clear();
            sessionStorage.clear();
        },
    }
});
